export default __webpack_public_path__ + "static/tools-bg3-7d689b8d4911ae3ff0a90921898a9c16.svg";